import { BasicButton } from "@certn/cascadia-react";
import { ChecksMonitoredTab as SharedChecksMonitoredTab } from "@certn/monitoring";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { EligibleMonitoringCheck, EnrollmentDetailCheck } from "../types";
import { CheckMonitoredCard } from "./CheckMonitoredCard";
import { EnrollCaseMonitoringModal } from "./EnrollCaseMonitoringModal";

interface Props {
  enrollments: EnrollmentDetailCheck[];
  eligibleChecks: EligibleMonitoringCheck[];
  canEnroll: boolean;
  onActionComplete: () => void;
}

export function ChecksMonitoredTab({
  enrollments,
  eligibleChecks,
  canEnroll,
  onActionComplete,
}: Props) {
  const { t } = useTranslation();
  const [isAddCheckOpen, setIsAddCheckOpen] = useState(false);

  return (
    <>
      <SharedChecksMonitoredTab
        enrollments={enrollments}
        headerActions={
          canEnroll ? (
            <BasicButton
              inverse
              size="small"
              leftIcon="add"
              isDisabled={eligibleChecks.length === 0}
              onPress={() => setIsAddCheckOpen(true)}
              testID="monitoring-add-check-button"
            >
              {t("Add check")}
            </BasicButton>
          ) : undefined
        }
        renderEnrollmentCard={(enrollment) => (
          <CheckMonitoredCard
            enrollment={enrollment}
            onActionComplete={onActionComplete}
          />
        )}
      />

      {isAddCheckOpen && (
        <EnrollCaseMonitoringModal
          checks={[...eligibleChecks]}
          onClose={() => setIsAddCheckOpen(false)}
          onSuccess={onActionComplete}
        />
      )}
    </>
  );
}
